export const defaultModalState = {
 
}

export type ModalType = ''
  | 'NONE' 
  | 'SELECT_USER_GENRES'
  | 'SEARCH_BOOKS_IN_MEET'
  | 'SELECT_CLUB_PROFILE'
  | 'SELECT_CLUB'
  | 'ADD_CLUB_CONFIRM'
